/**
 * 会員情報 store サービス
 */
import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { SupportClass } from '../../components/support-class';
import {
  AMCMemberStore,
  selectAMCMemberState,
  resetAMCMember,
  updateAMCMember,
  setAMCMember,
  AMCMemberState,
} from '../../store';
import { AMCMemberModel } from '../../interfaces';
import { filter } from 'rxjs/operators';
import { Observable } from 'rxjs/internal/Observable';
/**
 * 会員情報 store サービス
 * store情報
 * @param amcMemberData @see AMCMemberModel
 */
@Injectable()
export class AMCMemberStoreService extends SupportClass {
  private _amcMember$: Observable<AMCMemberState>;
  private _amcMemberData!: AMCMemberState;
  get amcMemberData() {
    return this._amcMemberData;
  }

  constructor(private _store: Store<AMCMemberStore>) {
    super();
    this._amcMember$ = this._store.pipe(
      select(selectAMCMemberState),
      filter((data) => !!data)
    );
    this.subscribeService('AMCMemberStoreServiceData', this._amcMember$, (data) => {
      this._amcMemberData = data;
    });
  }

  destroy() {}

  public getAMCMember$() {
    return this._amcMember$;
  }

  public updateAMCMember(value: Partial<AMCMemberModel>) {
    this._store.dispatch(updateAMCMember(value));
  }

  public updateAMCMemberByKey(key: keyof AMCMemberModel, value: any) {
    this._store.dispatch(updateAMCMember({ [key]: value }));
  }

  public setAMCMember(value: AMCMemberModel) {
    this._store.dispatch(setAMCMember(value));
  }

  public resetAMCMember() {
    this._store.dispatch(resetAMCMember());
  }
}
